/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {getRoutePageComponent, getContextRoutePageComponent} from '../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import _ from 'lodash';
import {getResourceItemTitleResolves} from '../base/default-item-title-view';
import {RouteTwoPanelLayoutComponent} from '../common/directives/route-two-panel-layout.component';
import {CreativeSetContextActionsComponent} from './creative-set-context-actions.component';
import {AdminResourceItemRoutePageComponent} from '../common/controller/admin-resource-item-route-page.component';
import {CreativeResource} from '../../components/api/resources/resource/creative.resource';
import {CreativeSetResource} from '../../components/api/resources/resource/creative-set.resource';
import {PERMISSIONS} from '../../components/auth/auth-constants';


export function creativeSetStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
let rh = adnRouterHelperProvider.$get().createRouterAndChildHelper('creative-sets.creative-set', CreativeSetResource, CreativeResource, 'app.adv', 'app');
        const itemState = rh.itemPath();
        $stateProvider.state(rh.listPath(), rh.list({
          views: {
            'content@app': { component: getRoutePageComponent('creative-set-route') }
          },
          resolve: {
            readOnly: function() {
              const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

              return !LocalUserPermissions.hasAny(PERMISSIONS.manageAdvertising.apiKey)
                && !LocalUserPermissions.hasAny(PERMISSIONS.axAdvertiser.apiKey)
                && !LocalUserPermissions.hasAny(PERMISSIONS.creativeAgency.apiKey);
            }
          }
        }))
          .state(rh.newItemPath(), rh.newItem())
          .state(rh.itemPath(), rh.modelCommsItem({
            resolve: _.merge({}, getResourceItemTitleResolves('CreativeSet'), {
              titleVariant: function() {
                return 'creative-set';
              },
              advertiserFromParam: /*@ngInject*/ function($stateParams) {
                if ($stateParams.advertiserId) {
                  return {
                    id: $stateParams.advertiserId,
                    name: $stateParams.advertiserName
                  };
                }
              },
              folioFromParam: /*@ngInject*/ function($stateParams) {
                if ($stateParams.folioId) {
                  return {
                    id: $stateParams.folioId,
                    name: $stateParams.folioName
                  };
                }
              },
              creativeSetEditRouteKey: function() {
                return 'creative-set-edit';
              },
              creativeSetAnalysisRouteKey: function() {
                return 'creative-set-analysis-edit';
              },
              routeEditVariant: function() {
                return 'edit';
              },
              creativeSetEditInputs: /*@ngInject*/ function(folioFromParam, advertiserFromParam) {
                return {folioFromParam, advertiserFromParam};
              }
            }),
            views: {
              // Direct UI-Router hosting (like blocklist / political-entity) so modelComms
              // reaches edit/analysis — not nested under an Angular item page.
              'content@app': {
                component: RouteTwoPanelLayoutComponent
              },
              ['leftPanel@' + itemState]: {
                component: AdminResourceItemRoutePageComponent,
                bindings: {
                  item: 'creativeSetEditRouteKey',
                  variant: 'routeEditVariant',
                  inputOverrides: 'creativeSetEditInputs'
                }
              },
              ['rightPanel@' + itemState]: {
                component: AdminResourceItemRoutePageComponent,
                bindings: {item: 'creativeSetAnalysisRouteKey', variant: 'routeEditVariant'}
              },
              'context@app': {
                component: CreativeSetContextActionsComponent,
                bindings: {model: 'model', modelComms: 'modelComms', isNew: 'isNew', readOnly: 'readOnly'}
              },
              // Do not pass objectType to modelCommsItem or it overwrites this title view.
              'title@app': rh.getResourceItemTitleView()
            }
          }));
  }, adnRouterHelper);
}
